import React from "react";
import {
  Checkbox, FormControl, FormHelperText, InputLabel, ListItemText, MenuItem, Select,
} from "@mui/material";
import { commonFieldSx, commonMenuProps } from "./dropdownStyles";

const normalizeOption = (item) =>
  typeof item === "object" ? item : { value: item, label: item };

export default function AppSelect({
  label,
  value,
  onChange,
  options = [],
  required = false,
  disabled = false,
  error = false,
  helperText,
  placeholder,
  allowClear = false,
  multiple = false,
  fullWidth = true,
  className,
  sx,
  name,
}) {
  const normalizedOptions = options.map(normalizeOption);
  const selectedValues = Array.isArray(value) ? value : [];
  const selectValue = multiple ? selectedValues : value ?? "";

  return (
    <FormControl
      name={name}
      required={required}
      disabled={disabled}
      error={error}
      fullWidth={fullWidth}
      size="small"
      className={className}
      sx={{ ...commonFieldSx, ...sx }}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        label={label}
        value={selectValue}
        multiple={multiple}
        displayEmpty={Boolean(placeholder)}
        onChange={(event) => {
          const nextValue = multiple && typeof event.target.value === "string"
            ? event.target.value.split(",")
            : event.target.value;
          onChange?.(nextValue, event);
        }}
        MenuProps={commonMenuProps}
        renderValue={(selected) => {
          const isEmpty = multiple ? !selected?.length : selected === "" || selected == null;
          if (isEmpty && placeholder) {
            return <span style={{ color: "#94a3b8" }}>{placeholder}</span>;
          }
          if (multiple) {
            const nextSelected = Array.isArray(selected) ? selected : [];
            return normalizedOptions
              .filter((item) => nextSelected.some((selectedValue) => String(selectedValue) === String(item.value)))
              .map((item) => item.label)
              .join(", ");
          }
          const selectedOption = normalizedOptions.find((item) => String(item.value) === String(selected));
          return selectedOption?.label ?? selected;
        }}
      >
        {allowClear && !multiple && <MenuItem value=""><em>Không chọn</em></MenuItem>}
        {normalizedOptions.map((item) => (
          <MenuItem key={item.value} value={item.value} disabled={item.disabled}>
            {multiple && (
              <Checkbox
                size="small"
                checked={selectedValues.some((selectedValue) => String(selectedValue) === String(item.value))}
              />
            )}
            {multiple ? <ListItemText primary={item.label} /> : item.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}
